/**
 * Модуль для управления playback боевого симулятора
 * Обёртки над функциями рендеринга для упрощения использования
 */

import {
  renderBattlePlaybackPanels,
  renderBattlePlaybackLog,
  renderBattlePlaybackStage,
  renderBattlePlaybackControls
} from './render.js';
import {
  renderBattlePlaybackPanels as renderPanelsOptimized,
  renderBattlePlaybackLog as renderLogOptimized,
  renderBattlePlaybackStage as renderStageOptimized
} from './renderOptimized.js';

/**
 * Рендеринг панелей бойцов (с fallback на стандартный рендеринг)
 */
export function renderBattlePanels(battleState) {
  if (!battleState || !battleState.panels) return;
  try {
    renderPanelsOptimized(battleState);
  } catch (error) {
    console.warn('[playback] Optimized render failed, falling back to standard:', error);
    renderBattlePlaybackPanels(battleState);
  }
}

/**
 * Рендеринг сцены боя (с fallback на стандартный рендеринг)
 */
export function renderBattleStage(battleState) {
  if (!battleState) return;
  try {
    renderStageOptimized(battleState);
  } catch (error) {
    console.warn('[playback] Optimized render failed, falling back to standard:', error);
    renderBattlePlaybackStage(battleState);
  }
}

/**
 * Рендеринг прогресса боя
 */
export function renderBattleProgress(battleState) {
  if (!battleState || !battleState.timeline) return;
  
  const progressLabel = document.getElementById("battle-playback-progress-label");
  const slider = document.getElementById("battle-playback-slider");
  
  if (progressLabel) {
    const current = (battleState.currentStep || 0) + 1;
    const total = battleState.timeline.length || 0;
    const newText = `${current} / ${total}`;
    if (progressLabel.textContent !== newText) {
      progressLabel.textContent = newText;
    }
  }
  
  if (slider) {
    const newMax = Math.max(0, (battleState.timeline.length || 0) - 1);
    const newValue = battleState.currentStep || 0;
    if (slider.max !== String(newMax)) {
      slider.max = String(newMax);
    }
    if (slider.value !== String(newValue)) {
      slider.value = String(newValue);
    }
  }
}

/**
 * Рендеринг лога боя (с fallback на стандартный рендеринг)
 */
export function renderBattleLog(battleState) {
  if (!battleState) return;
  try {
    renderLogOptimized(battleState);
  } catch (error) {
    console.warn('[playback] Optimized render failed, falling back to standard:', error);
    renderBattlePlaybackLog(battleState);
  }
}

/**
 * Рендеринг всех элементов playback
 */
export function renderBattlePlayback(battleState) {
  renderBattlePanels(battleState);
  renderBattleStage(battleState);
  renderBattleProgress(battleState);
  renderBattleLog(battleState);
  renderBattlePlaybackControls(battleState);
}

